// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-7197f1f3]{display:flex;justify-content:center}.error p[data-v-7197f1f3]{font-family:AvenirRoman;color:grey;border-radius:.375rem;font-weight:500;background-color:#fff;padding:.5rem 1rem;border:1px solid grey;box-shadow:0 0 10px #ccc;display:inline-block;margin:0 auto;text-align:center}.error p[data-v-7197f1f3]:hover{background-color:grey}.error p[data-v-7197f1f3]:focus{outline:none}", ""]);
// Exports
module.exports = exports;
